import { useField } from 'formik';
import { getError } from './input-components/index.js';
export const useFormField = (name) => {
    const [field, meta, helpers] = useField(name);
    return {
        value: field.value,
        onChange: field.onChange,
        onBlur: field.onBlur,
        error: meta.touched ? getError(meta.error) : undefined,
        helpers,
    };
};
//# sourceMappingURL=use-form-field.js.map